"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchNewXML = exports.searchNewExpression = void 0;
const xml_wrappers_1 = require("xml-wrappers");
function searchNewExpression(state, newExpression) {
    return {
        source: state.source,
        expression: newExpression,
        xmldoc: state.xmldoc,
        result: xml_wrappers_1.select(state.xmldoc, newExpression)
    };
}
exports.searchNewExpression = searchNewExpression;
function searchNewXML(state, newXML) {
    const xmldoc = new DOMParser().parseFromString(newXML, "text/xml");
    return {
        source: newXML,
        expression: state.expression,
        xmldoc: xmldoc,
        result: xml_wrappers_1.select(xmldoc, state.expression)
    };
}
exports.searchNewXML = searchNewXML;
